// Génère une URL optimisée pour une miniature Supabase Storage adaptée à la largeur souhaitée, sans crop
export function getOptimizedImageUrl(url: string, width: number, height?: number): string {
  if (!url) return '';
  if (url.includes('/render/image/')) {
    // Ajoute resize=contain si ce n'est pas déjà dans l'URL
    return url.includes('resize=contain') ? url : url + (url.includes('?') ? '&' : '?') + 'resize=contain';
  }
  let params = `?width=${width}`;
  if (height) params += `&height=${height}`;
  params += `&resize=contain`;
  return url.replace('/object/public/', '/render/image/public/') + params;
}
